import React from 'react';
import {Link} from 'react-router-dom'

const USSDServices = () => {
  const handleGetTestEnvironment = () => {
    // You can replace this with your actual contact form or email
    window.location.href = 'mailto:info@infinitytechafrica.com?subject=USSD Test Environment Request';
  };

  const handleContactTeam = () => {
    // You can replace this with your actual contact page or phone number
    window.location.href = 'tel:+254700000000'; // Replace with your actual phone number
  };

  const handleStartBuilding = () => {
    // Navigate to contact or signup page
    window.location.href = '/contact'; // Replace with your actual contact page route
  };

  return (
    <section id="ussd-services" className="py-16 bg-gradient-to-br from-purple-600 to-purple-800">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            USSD SERVICES
          </h2>
          <p className="text-purple-100 text-lg max-w-3xl mx-auto">
            Instant, Menu-Driven Interactions - No internet? No problem! Engage customers anytime, anywhere.
          </p>
        </div>

        {/* Main USSD Card */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:transform hover:scale-105 transition-all duration-300">
            <div className="relative">
              <img 
                src="/assets/USSDpage.png" 
                alt="USSD Services" 
                className="w-full h-64 object-cover"
              />
              <div className="absolute top-4 left-4 bg-purple-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                INSTANT ACCESS
              </div>
            </div>
            
            <div className="p-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-3">
                USSD Services – Instant, Menu-Driven Interactions
              </h3>
              <p className="text-purple-600 font-semibold mb-4 text-lg">
                No internet? No problem! Engage customers anytime, anywhere.
              </p>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                At Infinity Tech Africa, we offer USSD services in Kenya, Tanzania, Uganda, and Ghana, providing businesses with a reliable, accessible, and interactive channel to connect with their customers. USSD works on any mobile phone, from feature phones to smartphones, enabling real-time sessions through simple dial codes like *123#.
              </p>

              <div className="mb-6">
                <h3 className="font-bold text-blue-600 text-xl mb-3">USSD Menu Development Services</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  Bring your ideas to life with our custom USSD application development. Share your customer journey, and we'll transform it into a seamless, user-friendly USSD menu. Our team manages the technical side from design to telco integration so you can focus on engaging customers and delivering convenient services at their fingertips.
                </p>
              </div>

              <div className="mb-6">
                <h4 className="font-bold text-gray-800 mb-3">HOW DO I USE USSD SHORT CODE?</h4>
                <div className="bg-gray-50 rounded-lg p-4">
                  <div className="grid md:grid-cols-2 gap-3 text-gray-700">
                    <div className="flex items-start">
                      <span className="text-purple-600 mr-2">•</span>
                      <span>Mobile Banking & Payments <em>(balance checks, transfers, bill payments, airtime top-ups)</em></span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-purple-600 mr-2">•</span>
                      <span>Customer Self-Service <em>(account management, service activation, support requests)</em></span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-purple-600 mr-2">•</span>
                      <span>Data Collection & Surveys <em>(registrations, polls, field workforce reporting)</em></span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-purple-600 mr-2">•</span>
                      <span>Voting & Polling <em>(elections, contests, customer feedback campaigns)</em></span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-purple-600 mr-2">•</span>
                      <span>Subscription Management <em>(activations, renewals, opt-ins/outs)</em></span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-purple-600 mr-2">•</span>
                      <span>Agriculture & Rural Services <em>(market prices, weather updates, farming advice)</em></span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-purple-600 mr-2">•</span>
                      <span>Healthcare Access <em>(appointment booking, medication reminders, health campaigns)</em></span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-6">
                <h4 className="font-bold text-gray-800 mb-3">Why Choose Infinity Tech Africa?</h4>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="flex items-start">
                    <span className="text-purple-600 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Regional Coverage</strong> – Seamless deployment across Africa</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-purple-600 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Direct Telco Partnerships</strong> – Reliable connections with major mobile operators</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-purple-600 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>24/7 Technical Support</strong> – Always available for mission-critical services</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-purple-600 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Licensed by CAK</strong> – Licensed by the Communications Authority of Kenya</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-purple-600 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Custom Solutions</strong> – Tailored for banks, SACCOs, NGOs, and enterprises</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-purple-600 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Proven Expertise</strong> – Over 10 years delivering telecom software solutions</span>
                  </div>
                </div>
              </div>

              <p className="text-purple-600 font-semibold mb-6 text-center text-lg">
                Unlock the power of USSD solutions with Infinity Tech Africa and turn every phone into a powerful business tool.
              </p>

              <Link
                to="/contact"
                className="inline-flex items-center justify-center w-full bg-gradient-to-r from-blue-600 to-green-600 text-white py-3 px-6 rounded-lg font-semibold hover:from-blue-700 hover:to-green-700 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
              >
                <span>Start Building With USSD</span>
                <svg 
                  className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
                </svg>
              </Link>
            </div>
          </div>
        </div>

        {/* USSD Solutions Cards */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* Dedicated USSD Codes */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:transform hover:scale-105 transition-all duration-300">
            <div className="bg-gradient-to-r from-green-500 to-green-600 p-6">
              <h3 className="text-2xl font-bold text-white mb-2">Dedicated USSD Codes</h3>
              <p className="text-green-100">Get your own shortcode and own the experience</p>
            </div>
            
            <div className="p-6">
              <div className="mb-6">
                <h4 className="font-bold text-gray-800 mb-3">Advantages of a Dedicated USSD Code:</h4>
                <div className="space-y-2">
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Complete Brand Control</strong> – Deliver a consistent, branded user journey</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Unlimited Menu Depth</strong> – Build complex applications tailored to your needs</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Higher User Trust</strong> – Customers recognise and trust your unique shortcode</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Custom Analytics</strong> – Access detailed reports and usage insights</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Priority Support</strong> – Direct carrier-level support for mission-critical services</span>
                  </div>
                </div>
              </div>

              <div className="bg-green-50 rounded-lg p-4 mb-4">
                <p className="text-green-800 font-semibold">Dedicated USSD Codes are Ideal For:</p>
                <p className="text-green-700">Banks & Microfinance Institutions, Telecom Operators, Large Enterprises & SMEs, Government & NGOs</p>
              </div>
            </div>
          </div>

          {/* Shared USSD Codes */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:transform hover:scale-105 transition-all duration-300">
            <div className="bg-gradient-to-r from-blue-500 to-blue-600 p-6">
              <h3 className="text-2xl font-bold text-white mb-2">Shared USSD Codes</h3>
              <p className="text-blue-100">Affordable, fast, and flexible USSD solutions</p>
            </div>
            
            <div className="p-6">
              <div className="mb-6">
                <h4 className="font-bold text-gray-800 mb-3">Why Use Shared USSD Codes:</h4>
                <div className="space-y-2">
                  <div className="flex items-start">
                    <span className="text-blue-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Cost-Effective Entry</strong> – Lower setup and running costs</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-blue-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Quick Deployment</strong> – Go live within days, not months</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-blue-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Trusted Infrastructure</strong> – Partnerships with established telcos</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-blue-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Scalability</strong> – Start small and expand as your user base grows</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-blue-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Low-Risk Testing</strong> – Ideal for piloting new services</span>
                  </div>
                </div>
              </div>

              <div className="bg-blue-50 rounded-lg p-4 mb-4">
                <p className="text-blue-800 font-semibold">Shared USSD Codes are Best For:</p>
                <p className="text-blue-700">Startups & SMEs, NGOs & Donor Projects, Short-term campaigns, Market Testing</p>
              </div>
            </div>
          </div>
        </div>

        {/* Developer Features */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="bg-white rounded-2xl shadow-xl p-8">
            <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">Developer-Friendly Features</h3>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="flex items-start">
                <span className="text-purple-500 mr-3 text-lg">✔</span>
                <div>
                  <h4 className="font-bold text-gray-800">Test Code Environment</h4>
                  <p className="text-gray-600">Dedicated test codes to build, debug, and perfect applications</p>
                </div>
              </div>
              <div className="flex items-start">
                <span className="text-purple-500 mr-3 text-lg">✔</span>
                <div>
                  <h4 className="font-bold text-gray-800">Comprehensive APIs</h4>
                  <p className="text-gray-600">Easy integration with existing systems</p>
                </div>
              </div>
              <div className="flex items-start">
                <span className="text-purple-500 mr-3 text-lg">✔</span>
                <div>
                  <h4 className="font-bold text-gray-800">Documentation & Support</h4>
                  <p className="text-gray-600">Complete technical resources and developer assistance</p>
                </div>
              </div>
              <div className="flex items-start">
                <span className="text-purple-500 mr-3 text-lg">✔</span>
                <div>
                  <h4 className="font-bold text-gray-800">Multi-Country Coverage</h4>
                  <p className="text-gray-600">Seamless operations across East and West Africa</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-white mb-4">
              Ready to explore USSD for your business?
            </h3>
            <p className="text-purple-100 mb-6 text-lg">
              Contact us to discuss dedicated vs shared options and get your test environment set up today
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center bg-gradient-to-r from-blue-600 to-green-600 text-white px-8 py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-green-700 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
              >
                Contact Our Team
              </Link>
              {/* <Link
                to="/contact"
                className="inline-flex items-center justify-center border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
              >
                Contact Our Team
              </Link> */}
            </div>
            <p className="text-yellow-200 mt-6 text-sm">
              Powered by Infinity Tech Africa. Create. Transform.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default USSDServices;